module.exports = __webpack_public_path__ + "components/flag/static/square/xk-b09c9fe29093353006049c49fb83bea0.svg";